module.exports = require("http");


//////////////////
// WEBPACK FOOTER
// external "http"
// module id = 21
// module chunks = 0 1 2 3